/** Icon paths lifted verbatim from the locked reference so the port doesn't
 *  quietly substitute a different icon set. All are 20x20 stroke icons. */
const PATHS: Record<string, React.ReactNode> = {
  home: <path d="M3 8.5 10 3l7 5.5V16a1 1 0 0 1-1 1h-3v-5H7v5H4a1 1 0 0 1-1-1z" />,
  search: <><circle cx="9" cy="9" r="5.5" /><path d="m13.2 13.2 3.8 3.8" /></>,
  pipelines: <><circle cx="7" cy="6" r="2.4" /><circle cx="13.5" cy="6" r="2.4" /><circle cx="10" cy="13.5" r="2.4" /><path d="M8.6 8.1 9.6 11M11.4 8.1 10.4 11" /></>,
  saved: <path d="M5.5 3h9v14l-4.5-3.2L5.5 17z" />,
  recommended: <><circle cx="8" cy="6.5" r="2.6" /><path d="M3.5 16c0-2.6 2-4.6 4.5-4.6s4.5 2 4.5 4.6" /><path d="m14.5 4 .9 1.9 2 .3-1.5 1.4.4 2-1.8-1-1.8 1 .4-2-1.5-1.4 2-.3z" /></>,
  conversations: <path d="M3.5 5.5A1.5 1.5 0 0 1 5 4h10a1.5 1.5 0 0 1 1.5 1.5v6A1.5 1.5 0 0 1 15 13H8l-4.5 3.2z" />,
  interviews: <><circle cx="10" cy="10" r="7" /><circle cx="10" cy="10" r="2.6" /></>,
  documentation: <><path d="M5 3.5h6.5L15 7v9.5H5z" /><rect x="8" y="9" width="4" height="3.4" rx="1" /><path d="M9 9V8a1 1 0 0 1 2 0v1" /></>,
  team: <><circle cx="7.5" cy="7" r="2.4" /><circle cx="13.5" cy="8" r="2" /><path d="M3 16c0-2.5 2-4.4 4.5-4.4S12 13.5 12 16M13 11.8c2 0 3.7 1.6 3.7 3.7" /></>,
  trust: <><circle cx="10" cy="10" r="7" /><path d="M10 6.2v5M8 9l2-2.8L12 9" /></>,
  billing: <><path d="M13.5 6.5A3.5 3.5 0 0 0 7 8M6.5 13.5A3.5 3.5 0 0 0 13 12" /><path d="M13.5 4v2.5H11M6.5 16v-2.5H9" /></>,
  settings: <><circle cx="10" cy="10" r="2.5" /><path d="M10 3v2M10 15v2M17 10h-2M5 10H3M14.9 5.1l-1.4 1.4M6.5 13.5l-1.4 1.4M14.9 14.9l-1.4-1.4M6.5 6.5 5.1 5.1" /></>,
  profile: <><circle cx="10" cy="6.8" r="3" /><path d="M4 16.5c0-3.1 2.7-5.3 6-5.3s6 2.2 6 5.3" /></>,
  company: <><rect x="3.5" y="4.5" width="13" height="11" rx="2" /><path d="M3.5 7.5h13M7 3v3M13 3v3" /></>,
  bell: <><path d="M10 3a4.5 4.5 0 0 0-4.5 4.5c0 3.5-1.5 5-1.5 5h12s-1.5-1.5-1.5-5A4.5 4.5 0 0 0 10 3z" /><path d="M8.4 15.5a1.8 1.8 0 0 0 3.2 0" /></>,
  help: <><circle cx="10" cy="10" r="7.5" /><path d="M8 8a2 2 0 1 1 2.6 1.9c-.5.2-.6.6-.6 1.1v.4" /><circle cx="10" cy="14" r=".8" fill="currentColor" stroke="none" /></>,
}

export type IconName = keyof typeof PATHS

export function Icon({ name, className = 'ni' }: { name: IconName; className?: string }) {
  return (
    <svg className={className} viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.5" aria-hidden="true">
      {PATHS[name]}
    </svg>
  )
}
